'use client';

import type { ReactNode } from 'react';

import { Close } from '../Icons/Paths/Close';

import styles from './Styles/Default.module.css';

type AnnouncementBarProps = {
  icon?: ReactNode;
  children: ReactNode;
  onClose?: () => void;
};

export const AnnouncementBar = ({ icon, children, onClose }: AnnouncementBarProps) => {
  return (
    <div className={styles.bar} role="status" aria-live="polite" data-announcement-bar="">
      {icon && (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      <div className={styles.content}>{children}</div>
      {onClose && (
        <button type="button" className={styles.closeButton} aria-label="Close" onClick={onClose}>
          <Close fontSize={20} />
        </button>
      )}
    </div>
  );
};
